import $ from 'jquery';
import LazyLoad from "vanilla-lazyload";
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

let ScrollTriggerInit = gsap.registerPlugin( ScrollTrigger );

let mm = gsap.matchMedia();

//init ajax functions
//make sure naming conventiions are consistant in blade file
//ajax_init( cpt name, taxonomy name )
if ( $( '#news-filter' ).length ) {
  ajax_init( 'news', 'news_type' );
} 
if ( $( '#case-studies-filter' ).length ) {
  ajax_init( 'case-studies', 'case_type' );
} 

function cardAnimation( ) { 
  ScrollTriggerInit;
  let cards = document.querySelectorAll( '.card-anim-in' );
  
  cards.forEach((elem, i) => {  
    if ( ! $( elem ).hasClass( 'loaded' ) ) {
      let delay;
      let y;
      if( $( elem ).hasClass( 'two-grid-card' ) ) {
        if (i % 2 === 0) {  y = -20 }
        if ( (i - 1) % 2 === 0) { y = 20 }
      } else {
        if (i % 3 === 0 ) { y = -20 }
        if ( (i - 1) % 3 === 0) {  y = 20 }
        if ( (i - 2) % 3 === 0) {  y = 60 }
      }

      mm.add( '( max-width: 767px )', () => {
        y = 0;
      });
      mm.add( '( min-width: 767px ) and ( max-width: 959px )', () => {
        if (i % 2 === 0) {  y = -20 }
        if ( (i - 1) % 2 === 0) { y = 20 }
      });
      gsap.fromTo( 
        elem,
        { y: 100, opacity: 0 },
        { y: y, opacity: 1, delay: delay, 
          onComplete: function() {
          $(elem).addClass('loaded'); 
        },
          scrollTrigger: {
            trigger: elem,
            start:"top-=50 bottom", 
          }
        }
      ); 
    }
  });
}

function ajax_init ( cpt, term ) {

  let ajax_item = {'ajax_url':'\/wp\/wp-admin\/admin-ajax.php'};
  let heroText = document.getElementById('hero-tag-name');
  let container = $( '#' + cpt + '-container' );
  let cpt_ = cpt.replace( '-' , '_' );

  let currentFilter;
  let currentPage = 1;

  //on window load checking if theres a query parameter and filtering results
  $( () => {
    let query = window.location.search;
    let cat = query.split('=')[1];
    let filter = $('.filter-wrapper').find('[data-' + term + '=' + cat + ']')
    let filterName = $( filter ).find( '.filter-button' ).html()

    currentFilter = cat;

    if (  query && query.startsWith( '?cat=' )  ) {
      // heroText.innerHTML = 'on ' + filterName;
      $('#filters input').parent().parent().find( '.show-all-filter' ).removeClass( 'active' ); 
      $( filter ).find('input:radio').prop( 'checked', true );
      loadResults();
    } else {
      // set time out for preloader delay
      setTimeout( () => { cardAnimation() }, 1500 );
    }
  })

  //doing the main filtering, detecting change on checkbox and loading the ajax results
  $('#filters input').on('change', function( e ) {
    e.preventDefault();

    $( this ).parent().parent().find( '.show-all-filter' ).removeClass( 'active' );
    
    let name = $( this ).parent().find('.filter-button').html();
    let filter= $('.filter input:radio:checked').parent().data( term )

    if( filter === undefined ) {
      history.pushState( null, '', '?' );
      // heroText.innerHTML = '';
    } else {
      history.pushState( null, '', '?cat=' + filter );
      // heroText.innerHTML = 'on ' + name;
    }
    loadResults();

    currentFilter = filter;
  })

  //clears all filters and reloads all resuts
  $( '.show-all-filter' ).on( 'click', function() {
    let $this = $( this );
    // heroText.innerHTML = '';
    $this.addClass( 'active' );
    $this.parent().find('.filter input:checkbox').prop( 'checked', false );
    $this.parent().find('.filter input:radio').prop( 'checked', false );
    history.pushState( null, '', '?' );
    loadResults();
    currentFilter = undefined;
  })

  $('#load-more').on('click', function() {
    loadMoreResults( currentFilter );
  })
  //uses cpt var to definie container and filter results
  //make sure naming is accurate 
  function loadResults() {

    container.hide().empty();
    let data = $('#' + cpt + '-filter').serialize();

    $.ajax({
      type : 'GET',
      url: ajax_item.ajax_url,
      data: data,
      success: function( response ) {
        if (response.length ) {
          currentPage = 1;
          container.show().append( response );
          let myLazyLoad = new LazyLoad();

          setTimeout( () => { cardAnimation() }, 300 );
          
          var html = $.parseHTML(response);
          var postCount = $(html).find( '.cpt-card').length;
          
          if ( postCount < 12 ) {
            $( '#load-more' ).addClass( 'hidden' );
          } else {
            $( '#load-more' ).removeClass( 'hidden' );
          }
        }
      },
      error: function (response) {
        console.warn( response );
      }
    })
  }
  
  function loadMoreResults( currentFilter ) {

    currentPage++; // Do currentPage + 1, because we want to load the next page

    let data = {};
    data[ 'action' ] = 'load_more_'+ cpt_;
    data[ term ] = currentFilter;
    data[ 'paged' ] = currentPage;

    $.ajax({
      type: 'GET',
      url: ajax_item.ajax_url,
      data: data,
      success: function (response) {
        container.append( response );
        let myLazyLoad = new LazyLoad();
        cardAnimation() 

        var html = $.parseHTML(response);
        var postCount = $(html).find('.cpt-card').length;

        if ( postCount < 12 ) {
          $( '#load-more' ).addClass( 'hidden' );
        } else {
          $( '#load-more' ).removeClass( 'hidden' );
        }
      }
    });
    
  }
}

//News Type/Catagories Nav/Filter
//an accordion effect for the buttons
$( '.show-filters' ).on( 'click', function( e ) {
  e.preventDefault();

  var $this = $( this );
  var $content = $this.next();

  $this.parent().find( '.filter-wrapper' ).css( 'max-height', '0' );

  if ( $this.hasClass( 'open' ) ) {
    $this.removeClass( 'open' );
  } else {
    $this.siblings().removeClass( 'open' );
    $this.addClass( 'open' );
    $content.css( 'max-height', $content[0].scrollHeight );
  }
});
